import { LoginCallback, LogoutCallback } from '@myosh/myosh-login';
// Use react-router which is already installed; no separate react-router dependency required
import { Route, Routes } from 'react-router';
import LoginPage from '@/pages/login.page';
import MainPage from '@/pages/main.page';
import NoMatchRoute from '@/routes/no-match-route';
import PrivateRoute from '@/routes/private-route';

function App() {
  return (
    <Routes>
      <Route path="/auth/cb/logout" element={<LogoutCallback />} />
      <Route path="/auth/cb/silent" element={<div>Silent renewal callback</div>} />
      <Route path="/auth/cb" element={<LoginCallback />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route index element={<MainPage />} />
      </Route>
      <Route path="*" element={<NoMatchRoute />} />
    </Routes>
  );
}

export default App;
